import { render, staticRenderFns } from "./CategoryHeader.vue?vue&type=template&id=36d49e50&"
import script from "./CategoryHeader.vue?vue&type=script&lang=js&"
export * from "./CategoryHeader.vue?vue&type=script&lang=js&"
import style0 from "./CategoryHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
